/* facts-timeline.js · FACTS Prozess-Linie · v1 · 2026-09-02
 * ------------------------------------------------------------------
 * Die Linie folgt dem Scrollen: ihre Spitze steht immer auf dem
 * Ausloesepunkt (Anteil der Fensterhoehe, data-trigger). Ein Schritt
 * bekommt `is-on`, sobald die Spitze seinen Punkt erreicht hat, und
 * behaelt die Klasse (kein Flackern beim Zurueckscrollen).
 *
 * Kein requestAnimationFrame als einziger Takt: in verdeckten Tabs steht
 * rAF still (LEDGER-A 2026-09-02). Gerechnet wird direkt im Scroll-
 * Ereignis; pro Ereignis eine einzige Rechteckmessung, alle Punkt-
 * Positionen sind aus einer Messung beim Laden und bei Groessenaenderung
 * bekannt.
 *
 * Ohne Skript: kein `is-js`, alles sichtbar, Linie ueber die ganze Spur.
 */
(function () {
  'use strict';

  function init(root) {
    if (root._ftl) return;
    root._ftl = true;

    var track = root.querySelector('[data-ftl-track]');
    var rail = root.querySelector('[data-ftl-rail]');
    var steps = [].slice.call(root.querySelectorAll('[data-ftl-step]'));
    if (!track || !rail || !steps.length) return;

    var trigger = parseInt(root.getAttribute('data-trigger'), 10);
    if (isNaN(trigger)) trigger = 62;
    trigger = trigger / 100;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) root.classList.add('is-js');

    var railTop = 0;   /* Abstand Spur-Oberkante -> erster Punkt (px) */
    var railLen = 1;   /* Laenge erster Punkt -> letzter Punkt (px) */
    var dots = [];     /* Punkt-Mitten relativ zur Linien-Oberkante */

    function measure() {
      var t = track.getBoundingClientRect();
      var centers = steps.map(function (st) {
        var d = st.querySelector('[data-ftl-dot]');
        var r = (d || st).getBoundingClientRect();
        return r.top + r.height / 2 - t.top;
      });
      railTop = centers[0];
      railLen = Math.max(1, centers[centers.length - 1] - centers[0]);
      dots = centers.map(function (c) { return c - railTop; });
      rail.style.top = railTop + 'px';
      rail.style.bottom = 'auto';
      rail.style.height = railLen + 'px';
      update();
    }

    function update() {
      var t = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var tip = vh * trigger - t.top - railTop;      /* Spitze relativ zur Linien-Oberkante */
      var p = tip / railLen;
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      root.style.setProperty('--ftl-p', p.toFixed(4));
      var reach = reduce ? Infinity : tip + 1;
      for (var i = 0; i < steps.length; i++) {
        if (dots[i] <= reach) steps[i].classList.add('is-on');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(track);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }
    measure();
    /* Bilder, die spaeter kommen, aendern die Spur: ResizeObserver faengt
       das auf; hier nur ein zweiter Takt fuer Browser ohne ihn. */
    setTimeout(measure, 400);
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-ftl]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
